module.exports = __webpack_public_path__ + "img/title01.93fc63e9.png";